export type NicheType = 'generico' | 'clinica' | 'consorcio' | 'imobiliaria' | 'advocacia' | 'contabilidade' | 'varejo' | 'acm' | 'cursos';

export interface NicheLabels {
  leads: string;
  sales: string;
  dashboard: string;
  turmas?: string;
}

export const getNicheLabels = (niche?: string): NicheLabels => {
  const normalizedNiche = (niche || 'generico').toLowerCase() as NicheType;

  switch (normalizedNiche) {
    case 'cursos':
      return {
        leads: 'Alunos & Inscrições',
        sales: 'Matrículas',
        dashboard: 'Painel de Alunos & Turmas',
        turmas: 'Gestão de Turmas',
      };
    case 'acm':
      return {
        leads: 'Orçamentos (Oportunidades)',
        sales: 'Portas/Vendas',
        dashboard: 'ACM Dashboard',
      };
    case 'clinica':
      return {
        leads: 'Pacientes',
        sales: 'Tratamentos',
        dashboard: 'Clínica',
      };
    case 'imobiliaria':
      return {
        leads: 'Interessados',
        sales: 'Imóveis',
        dashboard: 'Vendas (VGV)',
      };
    case 'advocacia':
      return {
        leads: 'Consultas',
        sales: 'Contratos',
        dashboard: 'Escritório',
      };
    case 'consorcio':
      return {
        leads: 'Prospectos',
        sales: 'Cotas',
        dashboard: 'Consórcio',
      };
    case 'contabilidade':
      return {
        leads: 'Empresas',
        sales: 'Serviços',
        dashboard: 'Operação',
      };
    case 'varejo':
      return {
        leads: 'Clientes',
        sales: 'Pedidos',
        dashboard: 'Loja',
      };
    case 'generico':
    default:
      return {
        leads: 'Leads',
        sales: 'Vendas',
        dashboard: 'Dashboard',
      };
  }
};

// Configurações de Acesso para o Nicho de Cursos
export const hasAccessToCommercialFunnel = (role?: string) => {
  const r = (role || '').toLowerCase();
  return ['ceo', 'gestor', 'vendedor', 'sdr', 'superadmin'].includes(r);
};

export const hasAccessToTurmasFunnel = (role?: string) => {
  const r = (role || '').toLowerCase();
  return ['ceo', 'cs', 'superadmin'].includes(r);
};

export const hasAccessToFinancials = (role?: string) => {
  const r = (role || '').toLowerCase();
  return ['ceo', 'superadmin'].includes(r);
};

// Recebíveis (Gestão Unificada e controle de boletos): o CS enxerga e dá baixa nos recebimentos dos alunos, mas
// continua sem os indicadores financeiros da empresa (faturamento, despesas, EBITDA), que seguem só do CEO.
export const hasAccessToReceivables = (role?: string) => {
  const r = (role || '').toLowerCase();
  return ['ceo', 'superadmin', 'cs'].includes(r);
};
